export default "__VITE_ASSET__BOdeaFnm__"